import './issue-tags.css';
import angular from 'angular';
import IssueTagsComponent from './issue-tags.component';

export default angular.module('ttb.widgets.issueTags', [
])
    .component('issueTags', IssueTagsComponent)
    .name;




// WEBPACK FOOTER //
// ../widgets/issue-tags/index.js